

















































import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import HistoryChart from '@/world/HistoryChart.vue';
import { IWorldCountry } from '../models/world';

@Component({
	components: {
		HistoryChart,
	},
})
export default class AbroadInfo extends Vue {

	public get country(): IWorldCountry {
		return this.$store.getters['world/getCountry'];
	}

	private getImgUrl(operId: number) {
		switch (operId) {
			case 1: return '/img/megafon.png';
			case 2: return '/img/mts.png';
			case 3: return '/img/tele2.png';
			case 4: return '/img/beeline.png';
			case 5: return '/img/motive.png';
			default: return '';
		}
	}

	private getClassDiff(prev: number) {
		if (prev > 0) {
			return 'error--text';
		} else if (prev < 0) {
			return 'success--text';
		} else {
			return 'info--text';
		}
	}
}
